import React, { useState } from 'react'
import { Grid, Box, Button } from "@material-ui/core"
import { ideaEditStyles } from "./IdeaEditStyles"
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSelector, useDispatch } from 'react-redux'
import { ideaUpdateActions } from "./../../actions"
import { useParams } from 'react-router-dom';
import { DialogDeleteDraft } from '../../components';

export const IdeaEditActions = () => {
  const classes = ideaEditStyles();
  const dispatch = useDispatch();
  const { deleteLoading } = useSelector(state => state.idea)
  const { filesToRemove, saveLoading } = useSelector(state => state.ideaUpdate)
  const { fields } = useSelector(state => state.multiAreaCascade)
  const { ideaUpdate } = useSelector(state => state)
  const { id } = useParams();
  const [ deleteDialog, setDeleteDialog ] = useState(false)

  function handleSave() {
    if (filesToRemove.length > 0) {
      dispatch(ideaUpdateActions.sendRemoveFiles(id, filesToRemove));
    };
    dispatch(ideaUpdateActions.updateIdea(id, {
      ...ideaUpdate,
      businessUnitLocal: fields.filter(item => item.selectedBusinessUnit).map(item => item.selectedBusinessUnit),
    }));
  }

  function toggleDeleteDialog() {
    setDeleteDialog(!deleteDialog)
  }

  return (
    <>
    <DialogDeleteDraft open={deleteDialog} idea={ideaUpdate} onClose={toggleDeleteDialog} />
    { ideaUpdate?._id && (
      <Grid item container spacing={2} className={`${classes.root} ${classes.sticky}`}>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            className={classes.actionButton}
            onClick={handleSave}
            disabled={deleteLoading || saveLoading}
          >
            salvar ideia
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<DeleteIcon />}
            className={classes.actionButton}
            onClick={toggleDeleteDialog}
            disabled={deleteLoading || saveLoading}
          >
            excluir ideia
          </Button>
        </Grid>
      </Grid>
    )}
    </>
  )
}
